import { getPerfilUserAtualSomente } from '../../routes/private/PerfilUsuario/selector'
export function temPermissao(chaveRequerida, objPermissao) {
    if (objPermissao) {
        return objPermissao[chaveRequerida];
    } else {
        let permissoesPerfil;
        let perfil = getPerfilUserAtualSomente(); 
        if (perfil && perfil.permissoesPerfil) {
            permissoesPerfil = perfil.permissoesPerfil
        }
        let p = false;
        if (permissoesPerfil) {
            p = permissoesPerfil[chaveRequerida];
        }
        return p;
    }
    return false;


}


// WEBPACK FOOTER //
// ./src/modules/permissoes/functions.js